import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';

import ReactHtmlParser from 'react-html-parser';
import { css } from 'emotion';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import { Label } from '~/modules/coreUI/components/basic/Labels';

import {
  Tab, Tabs, TabList, TabPanel,
} from '~/modules/coreUI/components/layouts/Tabs';

import Specifications from './productTabs/Specifications';
import SellingShops from './productTabs/SellingShops';

const tabTabletStyles = props => css`
  padding-right: ${props.theme.paddings.large}px;
  padding-left: ${props.theme.paddings.large}px;

  font-size: ${props.theme.fonts.sizes.large}px;
`;

const tabListTabletStyles = () => css`
  padding-left: 0;

  text-align: left;
`;

const activeTabPanelStyles = props => css`
  padding-top: ${props.theme.paddings.xxLarge}px;
  padding-bottom: ${props.theme.paddings.xxLarge}px;
  padding-right: ${props.theme.paddings.large}px;
  padding-left: ${props.theme.paddings.large}px;
`;

const ProductTabs = props => (
  <Tabs className="productTabs">
    <TabList styles={(props.media.mobile || props.media.tablet) && tabListTabletStyles}>
      {!props.fromShops && (
        <Tab styles={(props.media.mobile || props.media.tablet) && tabTabletStyles}>
          {i18next.t('ecommerceCoreUI:Product.sellingShops.title')}
        </Tab>
      )}
      <Tab styles={(props.media.mobile || props.media.tablet) && tabTabletStyles}>{i18next.t('ecommerceCoreUI:Product.description')}</Tab>
      <Tab styles={(props.media.mobile || props.media.tablet) && tabTabletStyles}>
        {i18next.t('ecommerceCoreUI:Product.specifications')}
      </Tab>
    </TabList>
    {!props.fromShops && (
      <TabPanel activeStyles={activeTabPanelStyles}>
        <SellingShops onShopsLoaded={props.onShopsLoaded} />
      </TabPanel>
    )}
    <TabPanel activeStyles={activeTabPanelStyles}>
      {props.description ? ReactHtmlParser(props.description) : <Label>No Available Description</Label>}
    </TabPanel>
    <TabPanel activeStyles={activeTabPanelStyles}>
      {(props.hasSpecs) ? (
        <Specifications
          specifications={props.specifications}
          madeIn={props.madeIn}
          brand={props.brand}
          weight={props.weight}
          dimensions={props.dimensions}
        />
      ) : (
        <Label>
          {i18next.t('ecommerceCoreUI:Product.noSpecifications')}
        </Label>
      )}
    </TabPanel>
  </Tabs>
);

ProductTabs.defaultProps = {
  brand: null,
  madeIn: null,
  fromShops: false,
  hasSpecs: false,
  media: null,
  specifications: null,
  weight: null,
  dimensions: null,
  description: null,
};

ProductTabs.propTypes = {
  description: PropTypes.string,
  specifications: PropTypes.arrayOf(PropTypes.any),
  brand: PropTypes.string,
  madeIn: PropTypes.string,
  weight: PropTypes.string,
  dimensions: PropTypes.string,
  fromShops: PropTypes.bool,
  hasSpecs: PropTypes.bool,
  onShopsLoaded: PropTypes.func.isRequired,
  media: PropTypes.shape({
    mobile: PropTypes.bool,
    tablet: PropTypes.bool,
  }),
};

export default withMedia(ProductTabs);
